import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import FaqModal from 'containers/FaqModal';
import TermsOfServiceModal from 'containers/TermsOfServiceModal';
import Input from 'components/Input';
import LogoIcon from 'components/LogoIcon';
import ViewablePasswordField from 'components/ViewablePasswordField';
import Validators, { birthdayParse } from 'utils/fieldValidators';
import {
  DISPLAY_NAME_RULE_DESCRIPTION,
  PASSWORD_RULE_DESCRIPTION
} from 'utils/messages';
import { FaqLink, TermsOfServiceLink } from '../formConstants';
import './EmployeeFormPage.css';

class EmployeeFormPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
      showTos: false,
      showFaq: false
    };

    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.openTos = this.openTos.bind(this);
    this.closeTos = this.closeTos.bind(this);
    this.openFaq = this.openFaq.bind(this);
    this.closeFaq = this.closeFaq.bind(this);
  }

  togglePasswordVisibility() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  openTos(event) {
    event && event.preventDefault();
    this.setState({ showTos: true });
  }

  closeTos() {
    this.setState({ showTos: false });
  }

  openFaq(event) {
    event && event.preventDefault();
    this.setState({ showFaq: true });
  }

  closeFaq() {
    this.setState({ showFaq: false });
  }

  render() {
    const { formRenderer } = this.props;

    const tosLabel = <TermsOfServiceLink onClick={this.openTos} />;

    const body = (
      <Fragment>
        <div className="form-title">
          <LogoIcon />
        </div>
        <h2 className="sr-only focus-start" tabIndex="-1">
          Sign Up for Wind Creek Casino Online Account
        </h2>
        <div className="form-page employee-form-page">
          <Field
            name="email"
            component={Input}
            type="email"
            label="Email*"
            autoComplete="email username"
            disableOnSubmitting={true}
            tooltip="You will login with your email address"
            validate={Validators.employeeEmail}
            required
          />
          <Field
            name="confirmEmail"
            component={Input}
            type="email"
            label="Confirm Email*"
            autoComplete="email username"
            disableOnSubmitting={true}
            validate={Validators.reduxConfirmEmail}
            required
          />
          <Field
            name="password"
            component={ViewablePasswordField}
            showPassword={this.state.showPassword}
            toggleVisibility={this.togglePasswordVisibility}
            label="Password*"
            autoComplete="new-password"
            disableOnSubmitting={true}
            tooltip={PASSWORD_RULE_DESCRIPTION}
            validate={Validators.password}
            required
          />
          <Field
            name="confirmPassword"
            component={ViewablePasswordField}
            showPassword={this.state.showPassword}
            label="Confirm Password*"
            autoComplete="new-password"
            disableOnSubmitting={true}
            validate={Validators.reduxConfirmPassword}
            required
          />
          <Field
            name="displayName"
            component={Input}
            type="text"
            label="Display Name*"
            autoComplete="nickname"
            disableOnSubmitting={true}
            tooltip={`This is the name that will be displayed to others when you post on the site. ${DISPLAY_NAME_RULE_DESCRIPTION}`}
            validate={Validators.trimmedDisplayName}
            required
          />
          <Field
            name="dateOfBirth"
            component={Input}
            type="text"
            label="Date of Birth*"
            autoComplete="bday"
            placeholder="MM/DD/YYYY"
            disableOnSubmitting={true}
            parse={birthdayParse}
            validate={Validators.birthday}
            required
          />
          <Field
            name="agreeToTOS"
            component={Input}
            type="checkbox"
            label="Terms Of Service"
            labelNode={tosLabel}
            disableOnSubmitting={true}
            wrapperClass="form-tos"
            validate={Validators.termsOfService}
            aria-label="Terms of Service Checkbox"
            required
          />
          <FaqLink onClick={this.openFaq} />
          <TermsOfServiceModal
            onHide={this.closeTos}
            show={this.state.showTos}
          />
          <FaqModal onHide={this.closeFaq} show={this.state.showFaq} />
        </div>
      </Fragment>
    );

    return formRenderer(this.props, body);
  }
}

const reduxFormPage = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(EmployeeFormPage);

reduxFormPage.FormFields = [
  'email',
  'displayName',
  'password',
  'confirmPassword',
  'dateOfBirth',
  'agreeToTOS'
];

export default reduxFormPage;
